export default {
  title: 'Invoices',
  form: {
    auto_generate_invoices: {
      label: 'Auto generate invoices',
    },
  },
  buttons: {
    save: 'Save',
  },
  toasts: {
    failed_to_save_changes: 'Failed to save changes',
    changes_got_saved: 'Changes got saved',
  },
};
